import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DwMediaSelectorComponent, DwMediaModalService } from '@devwareapps/devware-cap';

@Component({
  selector: 'dw-media-selector2',
  template: `
    <div>
      <div [ngClass]="selectorClass" (click)="selectFiles()"  dwDwFileDrop (fileDrop)="selectFiles($event)">
        <div id="media-selector-inner" [hidden]="!showSelectorText" *ngIf="!disabled" >
          <i [ngClass]="selectorIcon"></i><br />
          <span id="media-selector-text">{{selectorText}}</span>
        </div>
        <ng-content></ng-content>
      </div>
    <input type="file" #fileSingle placeholder="Choose file" (change)="selectFiles(fileSingle.files, fileSingle)" [accept]="allowedFileTypes" style="display:none;">
  </div>
  `
})
export class DwMediaSelector2Component extends DwMediaSelectorComponent {
  @Input() mediaGroupId?: number;
  @Output() mediaGroupIdChange = new EventEmitter<number>();

  constructor(
    private dwMediaModalService2: DwMediaModalService,
  ) {
    super(dwMediaModalService2);
  }

  ngOnInit(): void {
  }

  selectFiles(event?: any, fileInput?: any): void {

    if (this.disabled) {
      return;
    }

    if (this.showFileSelectorFirst && !event) {
      this.fileSingle?.nativeElement?.click();
      return;
    }

    const options: any = {
      allowedFileTypes: this.allowedFileTypes,
      imageResizeOptions: this.isSvgSelection(event) ? null : this.resizeOptions || {
        cropWidth: 300,
        cropHeight: 300,
        cropRound: true,
      },
      isSecure: this.isSecure,
      parentItemName: this.parentItemName,
      parentAttributeName: this.parentAttributeName,
      uploadInstructions: this.uploadInstructions,
      maxFileSizeBytes: this.maxFileSizeMb * 1024 * 1024
    };

    this.dwMediaModalService2.showMultipleFileModal(options, this.mediaGroupId, event, 1, 0)
      .subscribe(uploadResult => {
        if (!uploadResult?.media?.length) {
          return;
        }

        if (uploadResult.mediaGroupId && uploadResult.mediaGroupId !== this.mediaGroupId) {
          this.mediaGroupId = uploadResult.mediaGroupId;
          this.mediaGroupIdChange.emit(this.mediaGroupId);
        }

        this.media = uploadResult.media[0]?.DwroMedia || uploadResult.media[0];
        this.mediaChange.emit(this.media);
      });
  }

  private isSvgSelection(files?: FileList): boolean {
    if (!files?.length) {
      return false;
    }

    return Array.from(files).some(file => file.name?.toLowerCase().endsWith('.svg'));
  }

}
 
